export default __webpack_public_path__ + "static/media/refresh.1f596eea.svg";